import { render, staticRenderFns } from "./service-region.vue?vue&type=template&id=d624ac76&"
import script from "./service-region.vue?vue&type=script&lang=js&"
export * from "./service-region.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports